import { STATE_LOGIN, STATE_SIGNUP } from "./pagecomponents/Login/AuthForm";
import GAListener from "./components/GAListener";
import {
  EmptyAdminLayout,
  LayoutAdminRoute,
  MainAdminLayout,
} from "./components/Layout";
import PageSpinner from "./components/PageSpinner";
import AuthPage from "./pages/AuthPage";
import MapRouter from "./pagecomponents/MapComponent/App";
import React from "react";
import componentQueries from "react-component-queries";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/reduction.scss";
import { AdminProtectedComponents } from "../utlis";
import ViewProfile from "../components/Layout/ViewProfile";
const DashboardPage = React.lazy(() => import("./pages/Homepage"));
const PersonalProfile = React.lazy(() => import("./pages/PersonalProfile"));
const Achivements = React.lazy(() => import("./pages/Achivements"));
const FamilyDirectory = React.lazy(() =>
  import("../pagecomponents/FamilyProfile/Components/FamilyProfileTable")
);
const Population = React.lazy(() => import("./pages/Population"));
const PopulationsDataTable = React.lazy(() =>
  import("./pagecomponents/Population/PopulationsDataTable")
);

const getBasename = () => {
  return `/${process.env.PUBLIC_URL.split("/").pop()}`;
};
const WardSearch = React.lazy(() =>
  import("../pagecomponents/WardPortal1/components/WardSearch")
);
toast.configure({
  autoClose: 5000,
  newestOnTop: true,
  hideProgressBar: true,
  closeButton: false,

  bodyClassName: "toastBody",
  position: "bottom-right",
});

class App extends React.Component {
  render() {
    return (
      <BrowserRouter basename={getBasename()}>
        <GAListener>
          <Switch>
            <LayoutAdminRoute
              exact
              path="/login"
              layout={EmptyAdminLayout}
              component={(props) => (
                <AuthPage {...props} authState={STATE_LOGIN} />
              )}
            />
            <MainAdminLayout breakpoint={this.props.breakpoint}>
              <AdminProtectedComponents>
                <React.Suspense fallback={<PageSpinner />}>
                  <MapRouter />
                  <Route exact path="/" component={DashboardPage} />
                  <Route
                    exact
                    path="/pariwarikjankari"
                    component={PersonalProfile}
                  />
                  {/* <Route exact path="/profile" component={WardSearch} /> */}
                  <Route
                    exact
                    path="/pariwarnirdeshika"
                    component={FamilyDirectory}
                  />
                  <Route exact path="/viewprofile" component={ViewProfile} />
                  <Route exact path="/jansankhya" component={Population} />
                  <Route exact path="/achivements" component={Achivements} />
                  <Route
                    exact
                    path="/population"
                    component={PopulationsDataTable}
                  />
                </React.Suspense>
              </AdminProtectedComponents>
            </MainAdminLayout>
            <Redirect to="/" />
          </Switch>
        </GAListener>
      </BrowserRouter>
    );
  }
}

const query = ({ width }) => {
  if (width < 575) {
    return { breakpoint: "xs" };
  }

  if (576 < width && width < 767) {
    return { breakpoint: "sm" };
  }

  if (768 < width && width < 991) {
    return { breakpoint: "md" };
  }

  if (992 < width && width < 1199) {
    return { breakpoint: "lg" };
  }

  if (width > 1200) {
    return { breakpoint: "xl" };
  }

  return { breakpoint: "xs" };
};

export default componentQueries(query)(App);
